angular.module('app').filter('parseUrlInText', function ($sce) {
    var urlRegex = /(\b(https?|ftp):\/\/[A-Z0-9+&@#\/%?=~_|!:,.;-]*[-A-Z0-9+&@#\/%=~_|])/gim;
    return function (text) {
        if (text.match(urlRegex)) {
            text = text.replace(urlRegex, '<a href="$1" target="_blank">$1</a>');
        }
        return $sce.trustAsHtml(text);
    };
});
